export default __webpack_public_path__ + "static/banner_3-7ea6f331aeedfe8360f162e7c87315e8.webp";